var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"share-wrap",class:_vm.type,style:([_vm.style]),attrs:{"open-type":"share"}},[_c('fc-icon',{attrs:{"type":_vm.icon}}),_c('span',[_vm._v("分享")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }